import React, { useState, useEffect } from "react";
import {
  Heart,
  AlertTriangle,
  Info,
  Clock,
  Shield,
  Star,
  ChevronDown,
  ChevronUp,
  Eye,
  Pill,
  Building,
  Thermometer,
  HelpCircle,
  BookOpen,
  Award,
  Package,
  Users,
} from "lucide-react";
import { useParams } from "react-router-dom";
import axios from "axios";
import SubstituteDrugsPage from "./SubstituteDrugsPage";

export default function DrugsIndividualPage() {
  const { id } = useParams();
  const [drugData, setDrugData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expandedSections, setExpandedSections] = useState({});
  const getDrugDetails = async (id) => {
    try {
      const res = await axios.get(
        `https://api.medstown.com/api/medshubs/drug/${id}`
      );
      console.log(res.data);
      setDrugData(res.data?.data);
    } catch (error) {
      console.error("Error fetching drug:", error);
    } finally {
      setLoading(false);
    }
  };
  // Mock data - replace with actual API call
  useEffect(() => {
    // Simulate API call

    getDrugDetails(id);
    //     const mockData = {
    //       success: true,
    //       status: 200,
    //       message: "Drug fetched successfully",
    //       data: {
    //         detailJson: {
    //           composition: {
    //             id: 209361,
    //             name: "Amlodipine",
    //             strength: {
    //               display_text: "5mg",
    //               unit: "mg",
    //               value: "5",
    //             },
    //             uses: {
    //               header: "Uses of A 1 Tablet",
    //               display_text:
    //                 "A 1 5mg Tablet is used in the treatment of Angina (heart-related chest pain) and Hypertension (high blood pressure).",
    //               values: [
    //                 {
    //                   name: "Angina (heart-related chest pain)",
    //                   prefix: "",
    //                   display_text: "Angina (heart-related chest pain)",
    //                   url: "/diseases/angina-heart-related-chest-pain-65",
    //                   description: "",
    //                 },
    //                 {
    //                   name: "Hypertension (high blood pressure)",
    //                   prefix: "Treatment of",
    //                   display_text:
    //                     "Treatment of Hypertension (high blood pressure)",
    //                   url: "/diseases/hypertension-high-blood-pressure-68",
    //                   description:
    //                     "A 1 5mg Tablet works by relaxing the blood vessels so that blood can flow more easily around your body. This lowers your blood pressure and reduces your risk of having a stroke, a heart attack, or kidney problems in the future.",
    //                 },
    //               ],
    //             },
    //             mechanism_of_action: {
    //               header: "How A 1 Tablet works",
    //               display_text:
    //                 "A 1 5mg Tablet is a calcium channel blocker. In high blood pressure, it normalizes the blood pressure by relaxing the blood vessels to reduce the pressure on them, thereby improving the blood flow in the body.",
    //             },
    //             expert_advice: {
    //               header: "Quick tips",
    //               display_text:
    //                 "<ul><li>You have been prescribed A 1 5mg Tablet to improve your blood pressure and/or to reduce the number and severity of angina attacks.</li><li>Lowering blood pressure reduces the chance of future heart attack and stroke.</li><li>Take it at the same time every day to help you remember to take it.</li><li>A sudden drop in your blood pressure may occur, especially when you first start taking A 1 5mg Tablet.</li><li>It can cause ankle or foot swelling. To reduce the swelling, raise your legs while you are sitting down.</li><li>It may cause dizziness. Do not drive or perform any activity that requires mental focus until you know how A 1 5mg Tablet affects you.</li><li>Inform your doctor if you are pregnant, planning a pregnancy or breastfeeding.</li></ul>",
    //             },
    //             how_to_take: {
    //               header: "How to use A 1 Tablet",
    //               display_text:
    //                 "Take this medicine in the dose and duration as advised by your doctor. Swallow it as a whole. Do not chew, crush or break it. A 1 5mg Tablet may be taken with or without food, but it is better to take it at a fixed time.",
    //             },
    //             side_effects: {
    //               header: "Side effects of A 1 Tablet",
    //               display_text:
    //                 "Most side effects do not require any medical attention and disappear as your body adjusts to the medicine. Consult your doctor if they persist or if you're worried about them.<br><b>Common side effects of A 1:</b><br><ul><li>Headache</li><li>Fatigue</li><li>Nausea</li><li>Abdominal pain</li><li>Sleepiness</li><li>Edema (swelling)</li></ul>",
    //             },
    //             introduction: {
    //               header: "Product introduction",
    //               display_text:
    //                 "A 1 5mg Tablet may be prescribed alone or along with other medicines. The dose depends on what you are taking it for and the severity of your condition. You can take it at any time of the day, with or without food, but it is best to take it at about the same time each day.",
    //               short_introduction:
    //                 "A 1 5mg Tablet belongs to a class of medicines known as calcium channel blockers. It is used to treat high blood pressure (hypertension) and prevent angina (heart-related chest pain).",
    //             },
    //             benefits: {
    //               header: "Benefits of A 1 Tablet",
    //               display_text:
    //                 "<div><b>Treatment of Hypertension (high blood pressure)</b><br>A 1 5mg Tablet works by relaxing the blood vessels so that blood can flow more easily around your body. This lowers your blood pressure and reduces your risk of having a stroke, a heart attack, or kidney problems in the future.</div>",
    //             },
    //             faqs: {
    //               header: "Frequently asked questions",
    //               data: [
    //                 {
    //                   question: "How long does it take for A 1 5mg Tablet to work?",
    //                   answer:
    //                     "A 1 5mg Tablet starts working on the day it is taken. However, it may take weeks to see the full effect.",
    //                 },
    //                 {
    //                   question: "Does A 1 5mg Tablet cause itching?",
    //                   answer:
    //                     "A 1 5mg Tablet may cause itching in some patients, though it is an uncommon side effect.",
    //                 },
    //                 {
    //                   question: "Is A 1 5mg Tablet bad for the kidneys?",
    //                   answer:
    //                     "No, there is no evidence that A 1 5mg Tablet causes deterioration of kidney problems.",
    //                 },
    //               ],
    //             },
    //           },
    //           safety_advice: {
    //             header: "Safety advice",
    //             data: [
    //               {
    //                 description:
    //                   "Caution is advised when consuming alcohol with A 1 5mg Tablet. Please consult your doctor.",
    //                 display_text: "Alcohol",
    //                 tag: { text: "CAUTION", bg_color: "#FFE0CC" },
    //               },
    //               {
    //                 description:
    //                   "A 1 5mg Tablet may be unsafe to use during pregnancy. Please consult your doctor.",
    //                 display_text: "Pregnancy",
    //                 tag: { text: "CONSULT YOUR DOCTOR", bg_color: "#D4FFFA" },
    //               },
    //               {
    //                 description:
    //                   "A 1 5mg Tablet is probably safe to use during breastfeeding.",
    //                 display_text: "Breast feeding",
    //                 tag: { text: "SAFE IF PRESCRIBED", bg_color: "#E2F6E7" },
    //               },
    //               {
    //                 description:
    //                   "A 1 5mg Tablet may cause side effects which could affect your ability to drive.",
    //                 display_text: "Driving",
    //                 tag: { text: "UNSAFE", bg_color: "#FFD9E1" },
    //               },
    //               {
    //                 description:
    //                   "A 1 5mg Tablet is safe to use in patients with kidney disease.",
    //                 display_text: "Kidney",
    //                 tag: { text: "SAFE IF PRESCRIBED", bg_color: "#E2F6E7" },
    //               },
    //               {
    //                 description:
    //                   "A 1 5mg Tablet should be used with caution in patients with liver disease.",
    //                 display_text: "Liver",
    //                 tag: { text: "CAUTION", bg_color: "#FFE0CC" },
    //               },
    //             ],
    //           },
    //           fact_box: [
    //             {
    //               header: "General Information",
    //               values: [
    //                 {
    //                   header: "Contains",
    //                   info_text: "Amlodipine (5mg)",
    //                 },
    //                 {
    //                   header: "Marketer",
    //                   info_text: "Patson Laboratories Pvt Ltd",
    //                 },
    //                 {
    //                   header: "Storage",
    //                   info_text: "Store below 30°C",
    //                 },
    //               ],
    //             },
    //           ],
    //           sku: {
    //             id: 252160,
    //             images: [
    //               {
    //                 medium:
    //                   "https://onemg.gumlet.io/l_watermark_346,w_480,h_480/a_ignore,w_480,h_480,c_fit,q_auto,f_auto/hx2gxivwmeoxxxsc1hix.png",
    //               },
    //             ],
    //             name: "A 1 5mg Tablet",
    //             therapeutic_class: "CARDIAC",
    //             marketer: {
    //               name: "Patson Laboratories Pvt Ltd",
    //               address:
    //                 "Plot No 2, Sonal Industrial Estate, Khoda, Sanand - 382110",
    //             },
    //           },
    //         },
    //         price: "12",
    //         pack_size_label: "strip of 10 tablets",
    //         rx_required: "Prescription Required",
    //         short_composition: "Amlodipine (5mg)",
    //         name: "A 1 5mg Tablet",
    //       },
    //     };

    //     setTimeout(() => {
    //       setDrugData(mockData.data);
    //       setLoading(false);
    //     }, 1000);
  }, [id]);

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const getSafetyColor = (tag) => {
    const colors = {
      CAUTION: "bg-orange-100 text-orange-800 border-orange-200",
      "CONSULT YOUR DOCTOR": "bg-cyan-100 text-cyan-800 border-cyan-200",
      "SAFE IF PRESCRIBED": "bg-green-100 text-green-800 border-green-200",
      UNSAFE: "bg-red-100 text-red-800 border-red-200",
    };
    return colors[tag] || "bg-gray-100 text-gray-800 border-gray-200";
  };

  const parseHTMLContent = (htmlString) => {
    if (!htmlString) return "";
    return htmlString.replace(/<[^>]*>/g, "");
  };

  const extractListItems = (htmlString) => {
    if (!htmlString) return [];
    const matches = htmlString.match(/<li[^>]*>(.*?)<\/li>/g);
    return matches
      ? matches.map((item) => item.replace(/<[^>]*>/g, "").trim())
      : [];
  };

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-b-2 border-blue-600"></div>
          <p className="">Loading drug information...</p>
        </div>
      </div>
    );
  }

  if (!drugData) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <p className="">Drug information not found</p>
        </div>
      </div>
    );
  }
  const {
    detailJson,
    price,
    pack_size_label,
    rx_required,
    short_composition,
    name,
    pwc,
    is_ayurvedha,
  } = drugData || {};

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="sticky top-0 z-10 bg-white shadow-sm">
        <div className="mx-auto max-w-6xl px-4 py-4">
          <div className="flex items-center space-x-3">
            <div className="flex h-16 w-16 items-center justify-center rounded-lg bg-blue-100">
              <Pill className="h-8 w-8 text-blue-600" />
            </div>
            <div className="flex-1">
              <div className="mb-2 flex items-start justify-between">
                <div>
                  <h1 className="flex-1 text-xl font-bold text-gray-900">
                    {name}
                  </h1>
                  <p className="text-sm">{short_composition}</p>

                  <div className="mt-1 flex items-center space-x-2">
                    <span className="text-lg font-bold text-green-600">
                      ₹{price}
                    </span>
                    <span className="text-sm text-gray-800">
                      ({pack_size_label})
                    </span>
                  </div>
                </div>
                <div className="ml-2 flex flex-col space-y-1">
                  <span
                    className={`rounded-full px-2 py-1 text-xs font-semibold ${
                      is_ayurvedha
                        ? "border border-green-200 bg-green-100 text-green-800"
                        : "border border-blue-200 bg-blue-100 text-blue-800"
                    }`}
                  >
                    {is_ayurvedha
                      ? "🌿 Ayurvedic Medicine"
                      : "💊 Allopathy Medicine"}
                  </span>

                  <span
                    className={`rounded-full px-2 py-1 text-xs font-semibold ${
                      pwc
                        ? "border border-red-200 bg-red-100 text-red-800"
                        : "border border-green-200 bg-green-100 text-green-800"
                    }`}
                  >
                    {pwc ? "⚠️ PWC Medicine" : "✅ Not a PWC Medicine"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-6xl space-y-6 px-4 py-6">
        {/* Prescription Required Banner */}
        {rx_required && (
          <div className="rounded-lg border border-red-200 bg-red-50 p-4">
            <div className="flex items-center space-x-2">
              <Shield className="h-5 w-5 text-red-600" />
              <span className="font-medium text-red-800">{rx_required}</span>
            </div>
          </div>
        )}

        {/* Quick Info Cards */}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <div className="rounded-lg border bg-white p-4 shadow-sm">
            <div className="flex items-center space-x-3">
              <Award className="h-6 w-6 text-blue-600" />
              {detailJson?.sku ? (
                <div>
                  <p className="text-sm">Therapeutic Class</p>
                  <p className="font-medium">
                    {detailJson.sku.therapeutic_class || "N/A"}
                  </p>
                </div>
              ) : (
                <div>
                  <p className="text-sm">Therapeutic Class</p>
                  <p className="font-medium">Loading...</p>
                </div>
              )}
            </div>
          </div>
          <div className="rounded-lg border bg-white p-4 shadow-sm">
            <div className="flex items-center space-x-3">
              <Building className="h-6 w-6 text-green-600" />
              <div>
                <p className="text-sm ">Marketer</p>
                <p className="font-medium">
                  {detailJson?.sku?.marketer?.name ? (
                    <p className="font-medium">
                      {detailJson.sku.marketer.name}
                    </p>
                  ) : (
                    <p className="font-medium">N/A</p>
                  )}
                </p>
              </div>
            </div>
          </div>
          <div className="rounded-lg border bg-white p-4 shadow-sm">
            <div className="flex items-center space-x-3">
              <Thermometer className="h-6 w-6 text-orange-600" />
              <div>
                <p className="text-sm ">Storage</p>
                <p className="font-medium">Store below 30°C</p>
              </div>
            </div>
          </div>
        </div>

        {/* Introduction */}
        {detailJson?.composition?.introduction && (
          <div className="rounded-lg border bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center space-x-2">
              <BookOpen className="h-6 w-6 text-blue-600" />
              <h2 className="text-xl font-bold text-gray-900">
                About This Medicine
              </h2>
            </div>
            <p className="leading-relaxed text-gray-700">
              {detailJson?.composition?.introduction?.short_introduction}
            </p>
          </div>
        )}

        {/* Uses */}
        {detailJson?.composition?.uses && (
          <div className="rounded-lg border bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center space-x-2">
              <Heart className="h-6 w-6 text-red-600" />
              <h2 className="text-xl font-bold text-gray-900">Uses</h2>
            </div>
            <p className="mb-4 text-gray-700">
              {detailJson?.composition?.uses?.display_text}
            </p>
            <div className="space-y-3">
              {detailJson?.composition?.uses?.values?.map((use, index) => (
                <div key={index} className="border-l-4 border-blue-500 pl-4">
                  <h3 className="font-medium text-gray-900">
                    {use?.display_text}
                  </h3>
                  {use.description && (
                    <p className="mt-1 text-sm ">{use.description}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* How it works */}
        {detailJson?.composition?.mechanism_of_action && (
          <div className="rounded-lg border bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center space-x-2">
              <Info className="h-6 w-6 text-purple-600" />
              <h2 className="text-xl font-bold text-gray-900">How It Works</h2>
            </div>
            <p className="leading-relaxed text-gray-700">
              {detailJson?.composition?.mechanism_of_action.display_text || "No information available."}
            </p>
          </div>
        )}

        {/* Benefits */}
        {detailJson?.composition?.benefits && (
          <div className="rounded-lg border bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center space-x-2">
              <Star className="h-6 w-6 text-yellow-600" />
              <h2 className="text-xl font-bold text-gray-900">Benefits</h2>
            </div>
            <div className="leading-relaxed text-gray-700">
              {parseHTMLContent(detailJson?.composition?.benefits?.display_text)}
            </div>
          </div>
        )}

        {/* How to take */}
        {detailJson?.composition?.how_to_take && (
          <div className="rounded-lg border bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center space-x-2">
              <Clock className="h-6 w-6 text-green-600" />
              <h2 className="text-xl font-bold text-gray-900">How to Take</h2>
            </div>
            <p className="leading-relaxed text-gray-700">
              {detailJson?.composition?.how_to_take?.display_text}
            </p>
          </div>
        )}

        {/* Side Effects */}
        {detailJson?.composition?.side_effects && (
          <div className="rounded-lg border bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center space-x-2">
              <AlertTriangle className="h-6 w-6 text-orange-600" />
              <h2 className="text-xl font-bold text-gray-900">Side Effects</h2>
            </div>
            <p className="mb-4 text-gray-700">
              Most side effects do not require any medical attention and
              disappear as your body adjusts to the medicine.
            </p>
            <div className="rounded-lg bg-orange-50 p-4">
              <h3 className="mb-2 font-medium text-orange-900">
                Common side effects:
              </h3>
              <div className="grid grid-cols-2 gap-2">
                {extractListItems(
                  detailJson?.composition?.side_effects.display_text
                ).map((effect, index) => (
                  <div key={index} className="flex items-center space-x-2">
                    <div className="h-2 w-2 rounded-full bg-orange-500"></div>
                    <span className="text-sm text-orange-800">{effect}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Safety Advice */}
        {detailJson?.safety_advice && (
          <div className="rounded-lg border bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center space-x-2">
              <Shield className="h-6 w-6 text-blue-600" />
              <h2 className="text-xl font-bold text-gray-900">Safety Advice</h2>
            </div>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              {detailJson?.safety_advice?.data?.map((advice, index) => (
                <div key={index} className="rounded-lg border p-4">
                  <div className="mb-2 flex items-center justify-between">
                    <h3 className="font-medium text-gray-900">
                      {advice?.display_text}
                    </h3>
                    <span
                      className={`rounded-full border px-2 py-1 text-xs font-medium ${getSafetyColor(
                        advice?.tag?.text
                      )}`}
                    >
                      {advice?.tag?.text}
                    </span>
                  </div>
                  <p className="text-sm ">{advice?.description}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Expert Advice */}
        {detailJson?.composition?.expert_advice && (
          <div className="rounded-lg border bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center space-x-2">
              <Users className="h-6 w-6 text-indigo-600" />
              <h2 className="text-xl font-bold text-gray-900">Expert Advice</h2>
            </div>
            <div className="space-y-3">
              {extractListItems(
                detailJson?.composition?.expert_advice?.display_text
              ).map((tip, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <div className="mt-1 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-indigo-100">
                    <span className="text-xs font-bold text-indigo-600">
                      {index + 1}
                    </span>
                  </div>
                  <p className="text-sm text-gray-700">{tip}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* FAQs */}
        {detailJson?.composition?.faqs && (
          <div className="rounded-lg border bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center space-x-2">
              <HelpCircle className="h-6 w-6 text-green-600" />
              <h2 className="text-xl font-bold text-gray-900">
                Frequently Asked Questions
              </h2>
            </div>
            <div className="space-y-4">
              {detailJson?.composition?.faqs.data?.map((faq, index) => (
                <div key={index} className="rounded-lg border border-gray-200">
                  <button
                    onClick={() => toggleSection(`faq-${index}`)}
                    className="flex w-full items-center justify-between px-4 py-3 text-left transition-colors hover:bg-gray-50"
                  >
                    <span className="font-medium text-gray-900">
                      {faq?.question}
                    </span>
                    {expandedSections[`faq-${index}`] ? (
                      <ChevronUp className="h-5 w-5 text-gray-800" />
                    ) : (
                      <ChevronDown className="h-5 w-5 text-gray-800" />
                    )}
                  </button>
                  {expandedSections[`faq-${index}`] && (
                    <div className="border-t border-gray-200 px-4 pb-3">
                      <p className="text-sm leading-relaxed text-gray-700">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Fact Box */}
        {detailJson?.fact_box && (
          <div className="rounded-lg border bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center space-x-2">
              <Package className="h-6 w-6 " />
              <h2 className="text-xl font-bold text-gray-900">
                Product Information
              </h2>
            </div>
            {detailJson?.fact_box?.map((box, boxIndex) => (
              <div key={boxIndex} className="mb-4">
                <h3 className="mb-3 font-medium text-gray-900">{box.header}</h3>
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  {box.values?.map((value, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-between rounded-lg bg-gray-50 p-3"
                    >
                      <span className="text-sm font-medium text-gray-700">
                        {value.header}
                      </span>
                      <span className="text-sm ">{value.info_text}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
        <div>
          <SubstituteDrugsPage item={drugData} />
        </div>
      </div>
    </div>
  );
}
